export default {
  text: '#2b2b2b',
  primary: '#d09c00',
  secondary: '#534030',
  background: '#fdfdfd',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: 'black'
}
